module.exports = __webpack_public_path__ + "img/modal-document-error-fl.6bff0769.svg";